/**
 * Tip component.
 */
import Bold from '@components/atoms/text/bold';
import TextContainer from '@components/atoms/text/tip';
import Pages from '@pages';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { useAppSelector } from '@shared/store/hooks';
import { routerSelector } from '@shared/store/slices/router.slice';

export default function Tip({
  alternateTip = false,
}: {
  alternateTip?: boolean;
}) {
  const { route } = useAppSelector(routerSelector);
  return alternateTip && route.Page === Pages.CHANNELS_GRID ? (
    <TextContainer id={'tipContainer'} bold={true}>
      {TranslationManager.get('MODAL.EPG_NOT_AVAILABLE.MESSAGE')}
    </TextContainer>
  ) : (
    <TextContainer id={'tipContainer'}>
      {TranslationManager.get('COMPONENTS.TIP.ACTIONS1')}
      <Bold>{TranslationManager.get('COMPONENTS.TIP.ACTIONS_CONFIRM')}</Bold>
      {TranslationManager.get('COMPONENTS.TIP.ACTIONS2')}
    </TextContainer>
  );
}
